import { attachHtmlToIframeWithNonce as b, buildBrazeBridge as N } from "../../util/html-display-utils.js";
import E from "../../../shared-lib/logger.js";
import { logBannerClick as _ } from "../log-banner-click.js";
export var BANNER_PLACEMENT_ID = "data-ab-banner-placement-id";
export var BANNER_HTML_CLASS = "ab-html-banner";
export var CONTROL_BANNER_HTML_CLASS = "ab-html-control-banner";
export function controlBannerToHtml(n) {
  var t = document.createElement("div");
  return t.id = n.id, t.className = "ab-html-control-banner", t.setAttribute(BANNER_PLACEMENT_ID, n.placementId), t;
}
export function bannerToHtml(n, t) {
  if (n.At()) return controlBannerToHtml(n);
  var e = document.createElement("iframe");
  return e.id = n.id, t && e.setAttribute("nonce", t), e.className = "ab-html-banner", e.setAttribute(BANNER_PLACEMENT_ID, n.placementId), e.setAttribute("title", "Banner"), b(e, n.html, t), e.onload = function () {
    var t = e.contentWindow,
      o = t.document.getElementsByTagName("title");
    o && o.length > 0 && e.setAttribute("title", o[0].textContent || "");
    var r = Object.assign(Object.assign({}, N(e)), {
      logClick: function logClick() {
        _.apply(void 0, [n].concat(Array.prototype.slice.call(arguments)));
      },
      closeMessage: function closeMessage() {},
      setBannerHeight: function setBannerHeight(n) {
        isNaN(n) || !isFinite(n) || n < 0 ? E.warn("Invalid banner height: ".concat(n)) : e.style.height = "".concat(n, "px");
      }
    });
    t.brazeBridge = r, t.appboyBridge = r, t.dispatchEvent(new CustomEvent("ab.BridgeReady"));
  }, e;
}